import MainPage from "./account.container";

export default MainPage;
